import Box from './box';
import { BoxElement } from './types';

const ChatAnswerBlockHeader = ({ children }: BoxElement) => {
  return <Box className="flex items-center justify-between cursor-move handler">{children}</Box>;
};

export default ChatAnswerBlockHeader;
